import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { ActivityMemoAction, ActivityMemoGetter } from '@/store/activityMemo/activityMemo.module';
import { ActivityAttachment, ActivityMemo } from '@/store/activityMemo/activityMemo.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ActivityAttachmentImageModalComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    activityId: {
      type: Number,
    },
    provinceId: {
      type: Number,
    },
    activityMemoId: {
      type: Number,
    }
  },
  setup: (props) => {
    const store = useStore();
    const swal = useSweetAlert();
    const activityMemo = computed<ActivityMemo | undefined>(() => store.getters[ActivityMemoGetter.BY_ID](props.activityMemoId));
    const images = computed<ActivityAttachment[]>(() => (activityMemo.value?.result?.attachments) ? activityMemo.value?.result?.attachments.filter(m => m.attachmentType.id === 2) : []);
    const isLoading = computed(() => store.getters[ActivityMemoGetter.STATUS] === 'init' || store.getters[ActivityMemoGetter.STATUS] === 'loading');
    const activityAttachmentImageModal = ref<InstanceType<typeof BaseModalComponent>>();
    const fileDialog = ref<HTMLInputElement>();

    // show modal
    const show = () => {
      activityAttachmentImageModal.value?.show();
    };

    // hide modal
    const hide = () => {
      activityAttachmentImageModal.value?.hide();
    };

    // open file dialog
    const fileDialogOpen = () => {
      fileDialog.value?.click();
    };

    const fileDialogChange = () => {
      const files = fileDialog.value?.files as FileList;
      store.dispatch(ActivityMemoAction.ADD_ATTACHMENTS, {
        activityId: props.activityId,
        provinceId: props.provinceId,
        id: props.activityMemoId,
        attachmentTypeId: 2,
        names: Array(files.length).fill('image'),
        attachments: files,
      });
    };

    const deleteImage = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(ActivityMemoAction.REMOVE_ATTACHMENTS, {
              activityId: props.activityId,
              provinceId: props.provinceId,
              id: props.activityMemoId,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      activityMemo,
      images,
      activityAttachmentImageModal,
      fileDialog,
      isLoading,
      show,
      hide,
      fileDialogOpen,
      fileDialogChange,
      deleteImage,
    };
  }
});
